import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';
import { facilityReadyGuard } from './core/guards/facility-ready.guard';
import { UserType } from './core/enums/user.enum';
import { userTypeGuard } from './core/guards/user-type.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES)
  },
  {
    path: 'perform/:episodeId',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/nc-perform/nc-perform.page').then((m) => m.NcPerformPageComponent)
  },
  {
    path: 'nc/assessment/:episodeId',
    loadComponent: () =>
      import('./pages/nc-perform/nc-perform.page').then((m) => m.NcPerformPageComponent)
  },
  {
    path: '',
    loadComponent: () =>
      import('./layout/shell-layout.component').then((m) => m.ShellLayoutComponent),
    canActivate: [authGuard, facilityReadyGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./features/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES)
      },
      {
        path: 'organization',
        canActivate: [userTypeGuard(UserType.AppAdmin)],
        loadChildren: () =>
          import('./features/organization/organization.routes').then((m) => m.ORGANIZATION_ROUTES)
      },
      {
        path: 'patients',
        loadChildren: () =>
          import('./features/patients/patients.routes').then((m) => m.PATIENTS_ROUTES)
      },
      {
        path: 'facilities',
        canActivate: [userTypeGuard(UserType.OrgUser)],
        loadChildren: () =>
          import('./features/facilities/facilities.routes').then((m) => m.FACILITIES_ROUTES)
      },
      {
        path: 'app-admins',
        canActivate: [userTypeGuard(UserType.AppAdmin)],
        loadChildren: () =>
          import('./features/app-admins/app-admins.routes').then((m) => m.APP_ADMINS_ROUTES)
      },
      {
        path: 'global-access',
        canActivate: [userTypeGuard(UserType.AppAdmin)],
        loadChildren: () =>
          import('./features/global-access/global-access.routes').then((m) => m.GLOBAL_ACCESS_ROUTES)
      },
      {
        path: 'admin-services',
        canActivate: [userTypeGuard(UserType.AppAdmin)],
        loadChildren: () =>
          import('./features/admin-services/admin-services.routes').then((m) => m.ADMIN_SERVICES_ROUTES)
      },
      {
        path: 'org-users',
        loadChildren: () =>
          import('./features/org-users/org-users.routes').then((m) => m.ORG_USERS_ROUTES)
      },
      {
        path: 'rules',
        loadChildren: () => import('./features/roles/roles.routes').then((m) => m.ROLES_ROUTES)
      },
      { path: 'roles', redirectTo: 'rules', pathMatch: 'full' },
      {
        path: 'logs',
        loadChildren: () => import('./features/logs/logs.routes').then((m) => m.LOGS_ROUTES)
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./features/settings/settings.routes').then((m) => m.SETTINGS_ROUTES)
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./features/profile/profile.routes').then((m) => m.PROFILE_ROUTES)
      },
      {
        path: 'opportunities',
        canActivate: [userTypeGuard(UserType.OrgUser)],
        loadChildren: () =>
          import('./features/opportunities/opportunities.routes').then((m) => m.OPPORTUNITIES_ROUTES)
          //import('./pages/opportunities/opportunities.component').then((m) => m.OpportunitiesComponent)
      },
      {
        path: 'oppo',
        canActivate: [userTypeGuard(UserType.OrgUser)],
        loadComponent: () =>
          import('./pages/opportunities/opportunities.component').then((m) => m.OpportunitiesComponent)
      },
      {
        path: 'activation-cases',
        canActivate: [userTypeGuard(UserType.OrgUser)],
        loadComponent: () =>
          import('./pages/activation-cases/activation-cases.component').then(
            (m) => m.ActivationCasesComponent
          )
      },
      {
        path: 'enrollments',
        canActivate: [userTypeGuard(UserType.OrgUser)],
        loadComponent: () =>
          import('./pages/enrollments/enrollments.component').then((m) => m.EnrollmentsComponent)
      },
      {
        path: 'episodes',
        canActivate: [userTypeGuard(UserType.OrgUser)],
        loadComponent: () =>
          import('./pages/episodes/episodes.component').then((m) => m.EpisodesComponent)
      },
      {
        path: 'claims',
        canActivate: [userTypeGuard(UserType.OrgUser)],
        loadComponent: () =>
          import('./pages/claims/claims.component').then((m) => m.ClaimsComponent)
      },
      {
        path: 'calls',
        canActivate: [userTypeGuard(UserType.OrgUser)],
        loadChildren: () =>
          import('./features/twilio-calls/twilio-calls.routes').then(
            (m) => m.TWILIO_CALLS_ROUTES
          )
      },
      {
        path: 'reconciliation',
        redirectTo: 'claims',
        pathMatch: 'full'
      },
      {
        // Unlisted on purpose: no sidebar entry, reached only by URL.
        path: 'insights',
        canActivate: [userTypeGuard(UserType.AppAdmin)],
        loadComponent: () =>
          import('./features/insights/insights.page').then((m) => m.InsightsPageComponent)
      },
      {
        path: 'admin',
        canActivate: [userTypeGuard(UserType.AppAdmin)],
        loadChildren: () => import('./pages/admin/admin.routes').then((m) => m.ADMIN_ROUTES)
      },
      {
        // Deliberately no userTypeGuard: this is where a clinician is sent to
        // install Synexa on their own machine, and they are not an app admin.
        path: 'extension-plugin',
        loadComponent: () =>
          import('./pages/extension-plugin/extension-plugin.page').then(
            (m) => m.ExtensionPluginPageComponent
          )
      }
    ]
  },
  { path: '**', redirectTo: 'dashboard' }
];
